// extracted by mini-css-extract-plugin
module.exports = {"icon":"BaseError_icon__awgD8"};